export default "__VITE_ASSET__DRYP48PY__"